enum CompanionApplicationEventTypeEnum {
  Pair = 'pair',
  LoginAndPair = 'loginAndPair',
}

export default CompanionApplicationEventTypeEnum;
